// extracted by mini-css-extract-plugin
export default {"page":"main_page__x8HyH"};